/* eslint-disable */

const transacts = {}
transacts.rentas = [
    'Alta - Beneficiarios EsSalud',
    'Baja - Beneficiarios EsSalud',
    'Aviso de fallecimiento',
    'Modificar número de cuenta',
    // 'Herencias',
    'Inclusión de beneficiario',
    'Exclusión de beneficiario',
    //'Pensión de Sobrevivencia',
    'Renovar Certificado de Estudios'
]

transacts.RentasRPP = [
    'Aviso de fallecimiento',
    'Modificar número de cuenta'
]

transacts.RentasInvSob = [
    'Alta - Beneficiarios EsSalud',
    'Baja - Beneficiarios EsSalud',
    'Aviso de fallecimiento',
    'Inclusión de beneficiario',
    'Exclusión de beneficiario',
    'Renovar Certificado de Estudios'
]

transacts.vida = [
    'Cuota comodín',
    'Liberación de endoso',
    'Endoso a entidad financiera',
    'Cambio Frecuencia de Pago',
    'Modificación de Beneficiarios',
    'Anulación de póliza',
    'Eliminación de cobertura'
]

transacts.masivos = [
    'Anulación de póliza'
]

transacts.codesGTM = {
    ANULACION_POLIZA: 'VIADP',
    ENDOSOS_ENTIDAD_FINANCIERA: 'VIEEF',
    CAMBIO_FRECUENCIA_PAGO: 'VICFP',
    CUOTA_COMODIN: 'VICCM',
    LIBERACION_ENDOSO: 'VILE',
    ALTA_BENEF_ESSALUD: 'REABE',
    BAJA_BENEF_ESSALUD: 'REBBE',
    AVISO_FALLEC: 'READF',
    MODIF_NUM_CUENTA: 'RECNC',
    INCLUSION_BENEF: 'REIBP',
    EXCLUSION_BENEF: 'REEBP',
    RENOV_CERTIF: 'RERCE',
    MODIFIC_BENEFICI: 'VIMDB',
    RETIRO_COBERTURAS: 'VIRCA'
}

transacts.products = {
    RENTA_VITALICIA: 'RRVV',
    RENTA_PARTICULAR_PLUS: 'RPP',
    RPP_IFP: 'IFP',
    RPP_ISD: 'ISD',
    RUMBO: 'rumbo'
}

transacts.cuentasBancarias = [{
    'entidad': 'Interbank',
    'code': 'IBK',
    'tipo_cuentas': [{
        'tipo': 'C. Ahorro',
        'format': '###-#########-#'
    },
    {
        'tipo': 'C. Corriente',
        'format': '###-#########-#'
    }
    ]
},
{
    'entidad': 'BCP',
    'code': 'BCP',
    'tipo_cuentas': [{
        'tipo': 'C. Ahorro',
        'format': '###-########-#-##'
    },
    {
        'tipo': 'C. Maestra',
        'format': '###-#######-#-##'
    },
    {
        'tipo': 'C. Corriente',
        'format': '###-#######-#-##'
    }
    ]
},
{
    'entidad': 'BBVA',
    'code': 'BBVA',
    'tipo_cuentas': [{
        'tipo': 'C. Ahorro',
        'format': '####-####-##-##########'
    }]
},
{
    'entidad': 'Scotiabank',
    'code': 'SCOTIABANK',
    'tipo_cuentas': [{
        'tipo': 'C. Ahorro',
        'format': '###-#######'
    }]
}
]

transacts.bancos = [
    {
        'text': 'BANCO DE CREDITO DEL PERU ',
        'value': '20100047218',
        'email': 'GOEAVISOSNOPAGO@BCP.COM.PE'
    },
    {
        'text': 'BANCO INTERNACIONAL DEL PERU-INTERBANK',
        'value': '20100053455',
        'email': 'ENDOSOSEGUROSINTERBANK@INTERCORP.COM.PE'
    },
    {
        'text': 'BANCO FALABELLA PERU S.A',
        'value': '20330401991',
        'email': 'SEGUROSSERVICIODECREDITOS@BANCOFALABELLA.COM.PE'
    },
    {
        'text': 'EDYFICAR PERU S.A.',
        'value': '20375312868',
        'email': 'POLIZAENDOSADA1@EDYFICAR.COM.PE'
    },
    {
        'text': 'BANCO GNB PERU S.A.',
        'value': '20513074370',
        'email': 'P_ENDOSO@BANCOGNB.COM.PE'
    },
    {
        'text': 'SCOTIABANK PERU SAA',
        'value': '20100043140',
        'email': 'CDERSEG@SCOTIABANK.COM.PE'
    },
    {
        'text': 'COMPARTAMOS FINANCIERA S.A.',
        'value': '20369155360',
        'email': 'RSAICO@COMPARTAMOS.COM.PE'
    },
    {
        'text': 'BANCO INTERAMERICANO DE FINANZAS',
        'value': '20101036813',
        'email': 'SEGUROS@BANBIF.COM.PE'
    },
    {
        'text': 'BANCO RIPLEY PERU S.A.',
        'value': '20259702411',
        'email': 'OPERACIONESSEGUROS@BANCORIPLEY.COM.PE'
    },
    /* {
        'text': 'DEUTSCHE BANK (PERÚ) S.A',
        'value': '',
        'email': ''
    }, */
    {
        'text': 'MIBANCO - BANCO DE LA MICROEMPRESA S.A.',
        'value': '20382036655',
        'email': 'SEGUROS.INSTITUCIONAL@MIBANCO.COM.PE'
    },
    {
        'text': 'BANCO BBVA PERÚ',
        'value': '20100130204',
        'email': 'CDERECHO.BANCARIO.SEGUROS.PE@BBVA.COM'
    },
    {
        'text': 'CREDISCOTIA FINANCIERA S.A.',
        'value': '20255993225',
        'email': 'CDERSEG@SCOTIABANK.COM.PE'
    },
    {
        'text': 'FINANCIERA CONFIANZA S.A.A. - FINANCIERA CONFIANZA',
        'value': '20228319768',
        'email': 'SEGUROS@CONFIANZA.PE'
    },
    /* {
        'text': 'FINANCIERA TFC',
        'value': '',
        'email': 'SEGUROS@TFC.COM.PE'
    }, */
    {
        'text': 'BANCO SANTANDER PERU S.A.',
        'value': '20516711559',
        'email': 'CONSULTASPN@SANTANDER.COM.PE'
    },
    {
        'text': 'FONBIENES PERU EMPRESA ADMINISTRADORA DE FONDOS COLECTIVOS S.A.',
        'value': '20523395701',
        'email': 'ATENCIONALCLIENTE@FONBIENES.COM.PE'
    },
    {
        'text': 'CAJA MUNICIPAL DE AHORRO Y CREDITO SULLANA S.A.',
        'value': '20102881347',
        'email': 'SCALLE@CMACSULLANA.COM.PE'
    },
    {
        'text': 'BANCO PICHINCHA',
        'value': '20100105862',
        'email': 'DANIELA.KOBAYASHI@PICHINCHA.PE'
    },
    {
        'text': 'PROMOTORA OPCION S.A. EAFC',
        'value': '20100341914',
        'email': 'MGALLO@OPCION.COM.PE'
    },
    {
        'text': 'OTROS',
        'value': 'otros',
        'email': ''
    }]

transacts.productosSinProyeccion = [
    'VIDAPROTECCION',
    'VIDAFREE',
    'VIDACASH',
    'VIDACASHSTOCK'
]


export default transacts



// WEBPACK FOOTER //
// ./src/interfaces/transacts.js